import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-027bca20"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "margin": "16px"
  }
};
const _hoisted_2 = {
  class: "taol"
};
const _hoisted_3 = ["checked"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 记住登录状态", -1));
import { ref } from "vue";
import api from "@/api/user";
import { showToast } from 'vant';
export default {
  __name: 'Login',
  emits: ['showTost'],
  setup(__props, {
    emit
  }) {
    const rememb = ref(false);
    const username = ref('');
    const password = ref('');
    const onRememb = () => {
      rememb.value = !rememb.value;
    };
    const onReg = () => {
      emit("showTost", 2);
    };
    const onSubmit = values => {
      values.rememb = rememb.value;
      api.Login(values).then(res => {
        if (res.code == 200) {
          localStorage.setItem("token", res.data.token);
          showToast({
            message: res.msg,
            wordBreak: 'break-word'
          });
          emit("showTost", 0);
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      return _openBlock(), _createBlock(_component_van_form, {
        onSubmit: onSubmit
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, {
          inset: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: username.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => username.value = $event),
            name: "user",
            label: "用户名",
            placeholder: "用户名",
            rules: [{
              required: true,
              message: '请填写用户名'
            }]
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => password.value = $event),
            type: "password",
            name: "pwd",
            label: "密码",
            placeholder: "密码",
            rules: [{
              required: true,
              message: '请填写密码'
            }]
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          onClick: onRememb
        }, [_createElementVNode("input", {
          type: "checkbox",
          name: "rememb",
          checked: rememb.value
        }, null, 8, _hoisted_3), _hoisted_4]), _createElementVNode("div", {
          class: "reg",
          onClick: onReg
        }, "还没账号，现在注册")]), _createVNode(_component_van_button, {
          round: "",
          block: "",
          type: "primary",
          "native-type": "submit"
        }, {
          default: _withCtx(() => [_createTextVNode(" 登陆 ")]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
};